import React, { useEffect,useRef,  useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Moment from 'react-moment';
import moment from 'moment';

function TestCards(){
    let totalTests ='';
    const state_test_data = useSelector(state => state.StateDisTable.state_testing_stats);
    const lastUpdated_data = useSelector(state => state.StateDisTable.lastUpdated);
    return(
    state_test_data !== undefined && state_test_data.length > 0?
<div>
    <div class='row' style={{width:'100%'}}>
            <div class="card col-md-4">
                    <div class="card-body">
                        <h5 class="card-title" style={{color:'#2a5ba5'}}>{parseInt(state_test_data[0].totaltested).toLocaleString()}</h5>
                        { <p class="card-text" style={{color:'#2a5ba5'}}>Samples tested till { <Moment format="LLs">
                            {moment(state_test_data[0].updatedon, 'DD-MM-YYYY HH:mm').format()}
                                </Moment> }.
                        </p> }
                    </div>
            </div>
           <div class="card col-md-4">
                     <div class="card-body">
                                     {state_test_data[0].positive != '' ? 
                                        <h5 class="card-title" style={{color:'red'}}>{parseInt(state_test_data[0].positive).toLocaleString()}</h5>
                                        :
                                        <h5 class="card-title" style={{color:'red'}}>-</h5>
                                        }
                                 <p class="card-text" style={{color:'red'}}>Positive samples found.</p>
                     </div>
           </div>
           <div class="card col-md-4">
                      <div class="card-body">
                                        {state_test_data[0].negative != '' ? 
                                        <h5 class="card-title" style={{color:'green'}}>{parseInt(state_test_data[0].negative).toLocaleString()}</h5>
                                        :
                                        <h5 class="card-title" style={{color:'green'}}>-</h5>
                                        }
                                        <p class="card-text" style={{color:'green'}}>Negative samples found.</p>
                        </div>
           </div>
            
   </div>

                      <div class='row' style={{width:'100%'}}>
                                {
                                    state_test_data[0].testpositivityrate != '' ?
                                    <div class="card col-md-4">
                                                    <div class="card-body">
                                                        <h5 class="card-title" style={{color:'cornflowerblue'}}>{state_test_data[0].testpositivityrate}</h5>
                                                        <p class="card-text" style={{color:'cornflowerblue'}}>Test Positivity Rate.</p>
                                                    </div>
                                    </div>
                                        :''
                                } 
                                {
                                    state_test_data[0].testspermillion != '' ?
                                    <div class="card col-md-4">
                                                    <div class="card-body">
                                                        <h5 class="card-title" style={{color:'rgba(165, 65, 42, 0.84)'}}>{state_test_data[0].testspermillion}</h5>
                                                        <p class="card-text" style={{color:'rgba(165, 65, 42, 0.84)'}}>Test Per Million.</p>
                                                    </div>
                                    </div>
                                        :''
                                } 
                                {
                                    state_test_data[0].testsperthousand != '' ?
                                    <div class="card col-md-4">
                                                    <div class="card-body">
                                                        <h5 class="card-title" style={{color:'rgb(152, 149, 52)'}}>{state_test_data[0].testsperthousand}</h5>
                                                        <p class="card-text" style={{color:'rgb(152, 149, 52)'}}>Test Per Thousand.</p>
                                                    </div>
                                    </div>
                                        :''
                                } 
                         </div>
                        <div class='row' style={{width:'100%'}}>
                            
                                    {
                                    state_test_data[0].numicubeds != '' ?
                                    <div class="card col-md-4">
                                                <div class="card-body">
                                                    <h5 class="card-title" style={{color:'rgb(42, 142, 165)'}}>{state_test_data[0].numicubeds}</h5>
                                                    <p class="card-text" style={{color:'rgb(42, 142, 165)'}}>ICU Beds Available.</p>
                                                </div>
                                    </div>
                                        :''
                                } 
                                {
                                    state_test_data[0].numisolationbeds != '' ?
                                    <div class="card col-md-4">
                                                <div class="card-body">
                                                    <h5 class="card-title" style={{color:'rgb(140, 86, 223)'}}>{state_test_data[0].numisolationbeds}</h5>
                                                    <p class="card-text" style={{color:'rgb(140, 86, 223)'}}>Isolation Beds Available.</p>
                                                </div>
                                        </div>
                                        :''
                                } 
                                {
                                    state_test_data[0].numventilators != '' ?
                                    <div class="card col-md-4">
                                                <div class="card-body">
                                                    <h5 class="card-title" style={{color:'rgb(67, 42, 165)'}}>{state_test_data[0].numventilators}</h5>
                                                    <p class="card-text" style={{color:'rgb(67, 42, 165)'}}>Ventilators Available.</p>
                                                </div>
                                        </div>
                                        :''
                                } 
                          

                        </div>
                    <div class='row' style={{width:'100%'}}>
                        <div class="card col-md-4">
                                                <div class="card-body">
                                                          <text class="LastUpdateLbl" style={{float:"left"}}>Last updated {moment(lastUpdated_data, 'DD-MM-YYYY HH:mm').toNow(true)} ago. </text>
                                                </div>
                        </div>
                        <div class="card col-md-4">
                                             
                        </div>
                        <div class="card col-md-4">
                                                <div class="card-body">
                                                            <a href={state_test_data[0].source1} class="btn popbtn btn-primary" style={{float:"right"}}>View Data Source</a>

                                                </div>
                        </div>
                           
                    </div>
</div>
 :
  ""
    )
}
export default TestCards